import React, { Component } from "react";
// reactstrap components
import { FormGroup, Input, Row } from "reactstrap";

export default class LikertInput extends Component {
  displayError() {
    const error = this.props.error;
    if (typeof error != "undefined" && error != null) {
      return <div className='text-danger'>{error.text}</div>;
    }
  }

  render() {
    return (
      <div className='pt-3 border-top'>
        <p className='font-weight-bold mb-4'>{this.props.qIndex}. {this.props.label}</p>
        <Row className='form'>
          <FormGroup className="custom-control custom-radio mb-3">
            <Input
              type='radio'
              className='custom-control-input'
              name={this.props.name}
              id={`${this.props.name}_sa`}
              value={5}
              checked={this.props.currentValue === 5}
              onChange={(e) => {
                this.props.handleChange(this.props.name, 5);
              }}
            />
            <label className='custom-control-label' htmlFor={`${this.props.name}_sa`}>Strongly Agree</label>
          </FormGroup>
          <FormGroup className="custom-control custom-radio mb-3">
            <Input
              type='radio'
              className='custom-control-input'
              name={this.props.name}
              id={`${this.props.name}_a`}
              value={4}
              checked={this.props.currentValue === 4}
              onChange={(e) => {
                this.props.handleChange(this.props.name, 4);
              }}
            />
            <label className='custom-control-label' htmlFor={`${this.props.name}_a`}>Agree</label>
          </FormGroup>
          <FormGroup className="custom-control custom-radio mb-3">
            <Input
              type='radio'
              className='custom-control-input'
              name={this.props.name}
              id={`${this.props.name}_n`}
              value={3}
              checked={this.props.currentValue === 3}
              onChange={(e) => {
                this.props.handleChange(this.props.name, 3);
              }}
            />
            <label className='custom-control-label' htmlFor={`${this.props.name}_n`}>Neither Agree or Disagree</label>
          </FormGroup>
          <FormGroup className="custom-control custom-radio mb-3">
            <Input
              type='radio'
              className='custom-control-input'
              name={this.props.name}
              id={`${this.props.name}_d`}
              value={2}
              checked={this.props.currentValue === 2}
              onChange={(e) => {
                this.props.handleChange(this.props.name, 2);
              }}
            />
            <label className='custom-control-label' htmlFor={`${this.props.name}_d`}>Disagree</label>
          </FormGroup>
          <FormGroup className="custom-control custom-radio mb-3">
            <Input
              type='radio'
              className='custom-control-input'
              name={this.props.name}
              id={`${this.props.name}_sd`}
              value={1}
              checked={this.props.currentValue === 1}
              onChange={(e) => {
                this.props.handleChange(this.props.name, 1);
              }}
            />
            <label className='custom-control-label' htmlFor={`${this.props.name}_sd`}>Strongly Disagree</label>
          </FormGroup>
        </Row>
        {this.displayError()}
      </div>
    );
  }
}
